import React, { useState, useContext } from "react";
const AuthContext = React.createContext();

const AuthProvider = ({ children }) => {
    const [compenentName , setCompenentName] = useState("List");
    const [isAuthentified, setIsAuthentified] = useState(true);
    const [code, setCode] = useState(0);
    const [user , setUser] = useState(null);
    const [bienInfoBase , setBienInfoBase] = useState({});
    const [showSlider, setShowSilder] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [language, setLanguage] = useState("fr");
    const [bundle, setBundle] = useState({});
    const annuler = ()=>{
      setCompenentName("List");
    }

    return <AuthContext.Provider value={
        {
            isAuthentified,
            code,
            user,
            showSlider,
            compenentName,
            bienInfoBase,
            showLoader,
            language,
            bundle,
            setIsAuthentified,
            setCode,
            setUser,
            setShowSilder, 
            setCompenentName,
            annuler,
            setBienInfoBase,
            setShowLoader,
            setLanguage,
            setBundle
        }}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
    return useContext(AuthContext);
}

export { AuthProvider }